import { createSelector } from 'reselect'
import { AppState } from 'store/types'

/**
 *
 * @param state - the application state
 * @returns fullEditShiftReducer
 */
export const selectFullEditShiftReducer = (state: AppState) =>
  state.fullEditShiftReducer

/**
 * Gets the editShiftModalInitialValues from fullEditShiftReducer
 */
export const selectEditShiftModalInitialValues = createSelector(
  selectFullEditShiftReducer,
  selectFullEditShiftReducer =>
    selectFullEditShiftReducer.editShiftModalInitialValues,
)

/**
 * Gets the edidShiftModalValues from fullEditShiftReducer
 */
export const selectEditShiftModalValues = createSelector(
  selectFullEditShiftReducer,
  selectFullEditShiftReducer => selectFullEditShiftReducer.editShiftModalValues,
)

/**
 * Gets the originalShift from fullEditShiftReducer
 */
export const selectOriginalShift = createSelector(
  selectFullEditShiftReducer,
  selectFullEditShiftReducer => selectFullEditShiftReducer.originalShift,
)
